
<template>
    <div style="margin-left:50px;">
  
      <el-form style="display: flex;flex-wrap: wrap;">
  
          <el-form-item label="学生姓名:" style="display: flex;width: 33%;" >
              <el-select placeholder="请选择学生姓名" v-model="value1"  style="width: 100%"  clearable   filterable >
                  <el-option   v-for="item in valueList1"  :key="item.id"  :value="item.id"  :label="item.realname"   >  </el-option>
              </el-select>
          </el-form-item>
  
  
          <el-form-item label="学科:" style="display: flex;width: 33%;">
              <el-select  placeholder="请选择学科"  v-model="value2" style="width: 100%"  clearable  filterable>
                  <el-option   v-for="item in valueList2" :key="item.id"  :value="item.id" :label="item.realname" >  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="是否排课成功:" style="display: flex;width: 33%;">
              <el-select  placeholder="请选择学科"  v-model="value3" style="width: 100%"  clearable  filterable>
                  <el-option   v-for="item in valueList3" :key="item.id"  :value="item.id" :label="item.realname" >  </el-option>
              </el-select>
          </el-form-item>
  

          <el-form-item label="日期:" style="display: flex;width: 100%;" >
            <el-date-picker  v-model="value4"   type="daterange"  range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
  
          
          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
          </div>
  
      </el-form>
  
  
      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="400">
          <el-table-column prop="courseDate" label="日期">
            <template slot-scope="scope">
               <span>{{scope.row.courseDate.substring(0,10)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="courseStartTime" label="学生姓名"></el-table-column>
          <el-table-column prop="courseEndTime" label="学科"></el-table-column>
          <el-table-column prop="subjectName" label="是否排课成功"></el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: space-around;">
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                </div>
              </template>
          </el-table-column>
        </el-table>
  
  
  
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>
  
  
  
      <el-dialog title="详情" width="50%" :visible.sync="ShowDlong" :before-close="commitCler">
          
          <div style="display: flex;justify-content: space-between;margin-bottom: 50px;">
             <div>姓名：初始化姓名</div>
             <div style="">科目：初始科目</div>
             <div style="">职级：初始化职级</div>
             <div style="">招聘渠道：初始化招聘渠道</div>
             <div style="">内推人：初始化内推人</div>
             <div style="">boss来源负责人：初始化boss来源负责人</div>
             <div style="">入职时间：初始化入职时间</div>
          </div>

      </el-dialog>
    
  
  </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";

import loadingUtils from "../utils/loading";

export default {

    data() {
        return {
            value1:"",
            value2:"",
            value3:"",
            valueList1:[{ id: 1, realname : '是' }, { id: 2, realname : '否' }],
            valueList2:[{ id: 1, realname : '是' }, { id: 2, realname : '否' }],
            valueList3:[{ id: 1, realname : '是' }, { id: 2, realname : '否' }],
            value4: [],
            requestParameters:{ pageNum:1, pageSize:10, total:0 },
            ShowDlong:false,
            dataList:[],
        }
    },

    mounted() {
       
    },
    

   methods:{

        clearBtns(){
            this.value1 = ""
            this.value2 = ""
            this.value3 = ""
            this.value4 = []
        },
        
        searchBtns(){
           
        },
        
        handleClickView(){
            this.ShowDlong = true
        },

        handleSizeChange(size){
            this.requestParameters.pageSize = size
        },

        handleCurrentChange(current){
            this.requestParameters.pageNum = current
        },

        commitCler(){
            this.ShowDlong = false
        },
   }

}
 

</script>


<style lang="less" scoped>


</style>


// WEBPACK FOOTER //
// src/IntelligentScheduling/CourseSchedulingRecords.vue